
import { Marked } from '@ts-stack/markdown'
import TurndownService from 'turndown'
import Vue from 'vue'
import {
  TiptapVuetify,
  Bold,
  Italic,
  Link,
  Strike,
  History,
  Paragraph,
  HardBreak
} from 'tiptap-vuetify'
import vuetify from '../plugins/vuetify'
import { VInput } from 'vuetify/lib'

const turndown = new TurndownService({
  emDelimiter: '_',
  linkStyle: 'inlined',
  headingStyle: 'atx'
})

turndown.addRule('strikethrough', {
  filter: ['del', 's'],
  replacement(content) {
    return `~~${content}~~`
  }
})

export default Vue.extend({
  name: 'WysiwygEditor',
  extends: VInput,
  components: {
    TiptapVuetify
  },
  props: {
    value: String
  },
  data() {
    return {
      extensions: [Bold, Strike, Italic, Link, Paragraph, History, HardBreak]
    }
  },
  computed: {
    mdValue: {
      set(newVal: string) {
        ;(this as any).$emit('input', turndown.turndown(newVal))
      },
      get() {
        return Marked.parse(this.value)
      }
    },
    vuetify() {
      return vuetify
    }
  },
  methods: {
    log() {
      console.log(this)
    }
  }
})
